const EditRestaurantTabs = {
  PUBLIC: 'public',
  MENU: 'menu',
  OPENING_HOURS: 'opening-hours',
  LEGAL: 'legal',
  FINANCE: 'finance',
  FEATURES: 'features',
  CONFIGURATION: 'configuration',
  THEME: 'theme',
  GROUPS: 'groups',
};

export default EditRestaurantTabs;
